import Menu from "./menu/menu.js";
import Search from "./search/search.js";

class Header {
  /**
   * @param {HTMLElement} element
   */
  constructor(element) {
    this.elements = {
      menu: element.querySelector(".js-HeaderMenu"),
      search: element.querySelector(".js-HeaderSearch"),
    };

    this.state = {
      open: null,
    };

    if (this.elements.menu) {
      this.menu = new Menu(this.elements.menu, this.render.bind(this));
    }

    if (this.elements.search) {
      this.search = new Search(this.elements.search, this.render.bind(this));
    }
  }

  /**
   * @param {HTMLElement} element
   * @param {boolean} isOpen
   */
  render(element, isOpen) {
    this.elements.menu.hidden = false;
    this.elements.search.hidden = false;

    if (element === "search" && isOpen) {
      this.elements.menu.hidden = true;
    }

    if (element === "menu" && isOpen) {
      this.elements.search.hidden = true;
    }
  }
}

export default Header;
